import { render, staticRenderFns } from "./Cost.vue?vue&type=template&id=2d3f1656&scoped=true&"
import script from "./Cost.vue?vue&type=script&lang=js&"
export * from "./Cost.vue?vue&type=script&lang=js&"
import style0 from "./Cost.vue?vue&type=style&index=0&id=2d3f1656&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d3f1656",
  null
  
)

export default component.exports